import type { Node, NodeProps } from "@xyflow/react";

import { Badge } from "@/components/ui/badge";
import { formatStatusLabel } from "@/lib/format";
import { getInventoryStatusBadgeClass } from "@/lib/status-tag-colors";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle, RightSourceHandle } from "./shared";
import type { CargoNodeData } from "./types";

type CargoFlowNode = Node<CargoNodeData, "cargo">;

export function CargoNode({ data }: NodeProps<CargoFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <RightSourceHandle />
      <FlowNodeCard
        title="Cargo"
        rightSlot={
          <Badge variant="outline" className={getInventoryStatusBadgeClass(data.status)}>
            {formatStatusLabel(data.status, "Unknown")}
          </Badge>
        }
      >
        <p className="text-sm font-semibold">{data.ociNumber || "OCI -"}</p>
        <FlowNodeRow label="Available Bags" value={data.availableBags ?? "-"} />
        <FlowNodeRow label="Total Bags" value={data.totalBags ?? "-"} />
      </FlowNodeCard>
    </>
  );
}
